import { Lock } from 'lucide-react';
import { cheapestPlanWith, type FeatureFlag, planName } from '../plans/features.ts';
import { usePlans } from '../plans/store.ts';

/** Small "🔒 Starter" badge on a gated control (docs/spec/08: show, don't hide). */
export function LockBadge({ flag }: { flag: FeatureFlag }) {
  const catalog = usePlans((s) => s.catalog);
  const plan = planName(cheapestPlanWith(flag, catalog), catalog);
  return (
    <span
      className="t-caption inline-flex shrink-0 items-center gap-1 rounded-full bg-accent-soft px-2 py-0.5 text-accent"
      title={`Included in ${plan}`}
    >
      <Lock size={11} strokeWidth={2.6} aria-hidden />
      {plan}
    </span>
  );
}
